/**
 *  Register.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 06/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import {
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

// redux
import { connect } from "react-redux";

// components
import { Card } from "../../components/Card/Card.jsx";
import VirtualFenceList from "./VirtualFenceList.jsx";
import Loading from "../Loader/Loader.jsx";

// notifications
import NotificationSystem from "react-notification-system";

// style
import "./style.css";
import { style } from "../../variables/Variables.jsx";
import PolygonMapComponent from "../../components/PolygonMap";
// global
var firebase = require("../../firebase");
var utils = require("../../utils");

class VirtualFence extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      coordinates: [],
      name: "",
      _notificationSystem: null,
      list: [],
    };
  }

  componentDidMount() {
    document.title = "Security Care | Cerca Virtual";
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    this.reloadData();
  }
  handlePolygonComplete = (area) => {
    console.log("coordinates", area);
    this.setState({ coordinates: area });
  };

  reloadData = () => {
    this.setState({ loading: true });
    firebase.database
      .ref("virtualFence")
      .orderByChild("createdAt")
      .once("value")
      .then((snap) => {
        let list = [];
        const values = snap.val();
        for (let key in values) {
          let value = values[key];
          value["key"] = key;
          if (value.status > 0) {
            list.unshift(value);
          }
        }
        this.setState({ list, loading: false });
      });
  };

  createNew = (_) => {
    const { name, coordinates } = this.state;
    if (name) {
      if (
        coordinates.length === 0 ||
        !coordinates[0] ||
        isNaN(Number(coordinates[0].lat)) ||
        isNaN(Number(coordinates[0].lng))
      ) {
        console.log("coordinates-error", coordinates);
        this.notify(
          "Coordenadas inválidas, reinicie o mapa e tente novamente.",
          "error"
        );
      } else {
        this.setState({ loading: true });
        firebase.database
          .ref("virtualFence")
          .push({
            createdAt: new Date().getTime(),
            status: 1,
            name,
            coordinates,
          })
          .then((_) => {
            this.setState({ name: "", coordinates: [] });
            this.notify("Cerca cadastrada com sucesso", "success");
            this.reloadData();
          });
      }
    } else {
      this.notify("Favor preencher todos os dados", "error");
    }
  };

  handleChange = (evt) => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  render() {
    const { name, list, loading } = this.state;
    console.log({ list_two: list });

    return (
      <div className="content bg-content">
        <NotificationSystem ref="notificationSystem" style={style} />
        <PolygonMapComponent
          handlePolygonComplete={this.handlePolygonComplete}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={
            <div style={{ height: `500px`, marginBottom: 60 }} />
          }
          mapElement={<div style={{ height: `100%` }} />}
        />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="CADASTRAR CERCA"
                content={
                  <div>
                    <Col md={3}>
                      <div className="form-group">
                        <FormGroup controlId="formControlsTextarea">
                          <ControlLabel style={{ fontWeight: "bold" }}>
                            Nome
                          </ControlLabel>
                          <FormControl
                            componentClass="input"
                            placeholder="Informe o nome"
                            name="name"
                            value={name}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div class="form-group">
                        <br></br>
                        <button
                          type="button"
                          class="btn btn-info labelless"
                          style={{ fontWeight: "bold" }}
                          onClick={this.createNew}
                        >
                          <span class="glyphicon glyphicon-plus"></span>{" "}
                          CADASTRAR
                        </button>
                      </div>
                    </Col>
                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {loading ? (
                <Loading />
              ) : (
                <VirtualFenceList list={list} reload={this.reloadData} />
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  users: store.users.users,
});

export default connect(mapStateToProps)(VirtualFence);



// WEBPACK FOOTER //
// ./src/views/VirtualFence/VirtualFence.jsx